<template>
    <div class="search">
        <Row>
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4" style="padding-right:10px">
                  <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{$t('alarms.common.all')}}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
        </Row>
    </div>
</template>
<script>
    import TableSlb from '../slb/TableSlb'
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    var tableSlb = TableSlb;
    export default {
        name: 'SlbSearch',
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                stateSearchKey: []
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
             getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableSlb.methods.showAll();
            }

        }
    }
</script>
<style scoped>
    .search
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/SlbSearch.vue